import React from 'react'
import { actions } from 'features/Cart'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import BenefitsHeader from './BenefitsShowcase/BenefitsHeader'
import BenefitsWrapper from './BenefitsShowcase/BenefitsWrapper'
import BenefitsItem from './BenefitsShowcase/BenefitsItem'

import '@loyal_template/showcases.css'

const BenefitsShowcase = ({ onlyCash, BenefitsInfo }) => {
  return BenefitsInfo.map((item, index) => ((
    <div key={index} className={`bx-benefitsShowcase pos-relative py-3 ${onlyCash ? 'scope-onlyCash' : 'scope-points'}`}>
      <div className='container px-1 px-sm-0'>
        <BenefitsHeader {...item} />
        <BenefitsWrapper>
          {
            item.banners.map((banner, bannerIndex) => (
              <BenefitsItem key={bannerIndex} bannerIndex={bannerIndex} {...banner} />
            ))
          }
        </BenefitsWrapper>
      </div>
    </div>
  )
  ))
}

BenefitsShowcase.propTypes = {
  onlyCash: PropTypes.bool,
  BenefitsShowcase: PropTypes.object
}
BenefitsShowcase.defaultProps = {
  BenefitsInfo: [{
    'title': 'Veja uma seleção de benefícios especiais para você.',
    'titleMobile': 'Benefícios especiais para você.',
    'banners': [
      { 'name': 'Beneficios', 'className': 'col-12 col-md-6 banner-home-beneficios', 'path': '/benefits/landing' },
      { 'name': 'Links',
        'className': 'mt-2 mt-md-0 col-12 col-md-6 banner-home-links',
        'path': '#',
        'items': [
          {
            'name': 'esportes',
            'description': 'descontos para você treinar em casa.',
            'icon': 'iconCamisa',
            'className': 'banner-home-beneficios-estilo pl-0 iconCamisa',
            'path': '/benefits/listing?category=Esporte'
          },
          {
            'name': 'alimentação',
            'description': 'descontos com benefícios exclusivos.',
            'icon': 'iconAlimentacao',
            'className': 'banner-home-beneficios-gastronomia pr-0',
            'path': '/benefits/listing?category=Alimentos'
          },
          {
            'name': 'saúde',
            'description': 'descontos nas principais farmácias.',
            'icon': 'iconSaude',
            'className': 'mt-2 banner-home-beneficios-cultura pl-0',
            'path': '/benefits/listing?category=Nutrição%20e%20Saúde'
          },
          {
            'name': 'educação',
            'description': 'descontos em audiobooks, podcasts e muito mais.',
            'icon': 'iconEducacao',
            'className': 'mt-2 banner-home-beneficios-viagens pr-0',
            'path': '/benefits/listing?category=Entretenimento'
          }
        ] }

    ]
  }]
}
const mapStateToProps = ({ onlyCash }) => ({ onlyCash })

const mapDispatchToProps = dispatch => ({
  loadCart: () => dispatch(actions.loadCart())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BenefitsShowcase)



// WEBPACK FOOTER //
// ./src/Catalog/Showcase/BenefitsShowcase.js